__turbopack_context__.v({
  "clearButton": "PB-HgW_clearButton",
  "flushButton": "PB-HgW_flushButton",
  "root": "PB-HgW_root",
  "singleView": "PB-HgW_singleView",
});
